/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/product';
import '../../resources/subscription';
import '../../common/locale';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "SoftwareProductGroupType": {
                    "values": {
                      "RESTAURANTS": 1,
                      "POS": 2,
                      "RETAIL": 3,
                      "APPOINTMENTS": 4,
                      "ONLINE": 5
                    }
                  },
                  "SoftwareProductPlan": {
                    "fields": {
                      "product": {
                        "type": "squareup.solidshop.v2.resources.Product",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subscriptions": {
                        "type": "squareup.solidshop.v2.resources.Subscription",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "SoftwareProductGroup": {
                    "fields": {
                      "groupType": {
                        "type": "squareup.solidshop.v2.service.SoftwareProductGroupType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "plans": {
                        "type": "squareup.solidshop.v2.service.SoftwareProductPlan",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ListSoftwareProductGroupsRequest": {
                    "fields": {
                      "storeCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      }
                    }
                  },
                  "ListSoftwareProductGroupsResponse": {
                    "fields": {
                      "softwareProductsGroups": {
                        "type": "squareup.solidshop.v2.service.SoftwareProductGroup",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SoftwareProductGroupType && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SoftwareProductPlan && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SoftwareProductGroup && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.ListSoftwareProductGroupsRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.ListSoftwareProductGroupsResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE SoftwareProductGroupType @ squareup/solidshop/v2/service/products/list_software_product_groups.proto at 14:1
 */
export const SoftwareProductGroupType = $root.lookupEnum('squareup.solidshop.v2.service.SoftwareProductGroupType').values;
/**
 * SOURCE SoftwareProductPlan @ squareup/solidshop/v2/service/products/list_software_product_groups.proto at 22:1
 */
export const SoftwareProductPlan = $root.lookupType('squareup.solidshop.v2.service.SoftwareProductPlan');
fixType(SoftwareProductPlan, {
  product: { required: true },
});
Builder.createAndAttachToType(SoftwareProductPlan);
/**
 * SOURCE SoftwareProductGroup @ squareup/solidshop/v2/service/products/list_software_product_groups.proto at 30:1
 */
export const SoftwareProductGroup = $root.lookupType('squareup.solidshop.v2.service.SoftwareProductGroup');
fixType(SoftwareProductGroup, {
  groupType: { required: true },
});
Builder.createAndAttachToType(SoftwareProductGroup);
/**
 * SOURCE ListSoftwareProductGroupsRequest @ squareup/solidshop/v2/service/products/list_software_product_groups.proto at 38:1
 */
export const ListSoftwareProductGroupsRequest = $root.lookupType('squareup.solidshop.v2.service.ListSoftwareProductGroupsRequest');
fixType(ListSoftwareProductGroupsRequest);
Builder.createAndAttachToType(ListSoftwareProductGroupsRequest);
/**
 * SOURCE ListSoftwareProductGroupsResponse @ squareup/solidshop/v2/service/products/list_software_product_groups.proto at 46:1
 */
export const ListSoftwareProductGroupsResponse = $root.lookupType('squareup.solidshop.v2.service.ListSoftwareProductGroupsResponse');
fixType(ListSoftwareProductGroupsResponse);
Builder.createAndAttachToType(ListSoftwareProductGroupsResponse);
